import { render, staticRenderFns } from "./BalanceSheetDetailedVertical.vue?vue&type=template&id=ed1a0a62"
import script from "./BalanceSheetDetailedVertical.vue?vue&type=script&lang=js"
export * from "./BalanceSheetDetailedVertical.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports